import React from "react";
import { useAuthContext } from "src/auth/useAuthContext";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ component: Component, permission, superAdminRoute, canAccess, ...rest }) => {
  const { user } = useAuthContext();
  if (!user || user.isProfileComplete === false) {
    return <Navigate to="/auth/sign-up" replace />;
  }
  if (superAdminRoute && !user?.isSuperAdmin) {
    return <Navigate to="/404" />;
  }
  if (permission && !user?.permissions?.[permission]) {
    return <Navigate to="/404" />;
  }
  if (canAccess && !canAccess(user)) {
    return <Navigate to="/404" />;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
